import {processAPIResponse} from "@/utils/request";
import {message} from "antd";

import {
  createCSVLeadSourceRequest,
  deleteLeadSource,
  editLeadSourceRequest,
  fetchLeadFields,
  fetchLeadSources,
  fetchManagedLeadSources,
  getLeadSource,
  setDefaultLeadSourceRequest,
  updateCSVLeadSourceRequest,
} from "@/services/api/lead";
import {fetchMeRequest} from "@/services/api/user";


const initialState = {
  leadSourceList: [],
  // Lead Sources management view (Integrations > Lead Sources). Sourced from the
  // Laravel api/v4/partner/lead-sources index, kept separate from leadSourceList
  // (legacy /leads/leadSources) which still feeds the journey-style selectors.
  managedList: [],
  leadDetailsDrawer: null,
  leadSourceDetail: {lead_source: {}},
  leadFields: {
    default: [],
    meta: []
  },

}
export default {
  namespace: 'leadSources',

  state: initialState,

  effects: {

    * fetchLeadSources({payload = {}}: { payload: { search?: string, url?: string } }, {call, put, select}) {
      const {response, data} = yield call(fetchLeadSources);
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'setLeadSources',
            payload: {
              leadSourceList: data
            }
          })
        }
      })
    },
    * fetchManagedLeadSources(_, {call, put}) {
      const {response, data} = yield call(fetchManagedLeadSources);
      yield processAPIResponse({response, data}, {
        * onSuccess(list) {
          yield put({
            type: 'setManagedLeadSources',
            payload: {managedList: list || []}
          })
        }
      }, 'data')
    },
    * editLeadSource({payload: {id, values, cb}}: { payload: { id: string, values: Record<string, unknown>, cb?: (err: any, data?: any) => void } }, {call, put}) {
      const {response, data} = yield call(editLeadSourceRequest, {
        params: {sourceId: id},
        data: values,
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(updated) {
          yield put({
            type: 'updateManagedLeadSource',
            payload: {leadSource: updated}
          })
          cb && cb(null, updated)
        },
        * onError(error) {
          message.error(error?.message || error?.error?.message)
          cb && cb(error)
        }
      }, 'data')
    },
    /**
     * Promote a lead source to the partner's default.
     *
     * Every other lead source falls back to the default for anything it has no
     * configuration row of its own for — email config and templates included —
     * so on success three things go stale at once: the managed list's is_default
     * flags, the `journey.list` copy of those flags (`/me`, read by
     * selectDefaultLeadSource and the journey scope bar), and every merged
     * journey configuration cached under `journey.config`, which was merged over
     * the *previous* default.
     */
    * setDefaultLeadSource({payload: {id, cb}}: { payload: { id: string, cb?: (err: any) => void } }, {call, put}) {
      const {response, data} = yield call(setDefaultLeadSourceRequest, {params: {sourceId: id}});
      yield processAPIResponse({response, data}, {
        * onSuccess() {
          yield put({
            type: 'setDefaultManagedLeadSource',
            payload: {id}
          })
          yield put({type: 'journey/clearConfig'})
          yield put({type: 'fetchMe'})
          cb && cb(null)
        },
        * onError(error) {
          message.error(error?.message || error?.error?.message)
          cb && cb(error)
        }
      }, 'data')
    },
    * fetchLeadFields({payload = {}}: { payload: { search?: string, url?: string } }, {call, put, select}) {
      const {response, data} = yield call(fetchLeadFields);
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'saveLeadFields',
            payload: data?.data
          })
        }
      })
    },

    * fetchMe({payload = {}}, {call, put, select}) {
      const {response, data} = yield call(fetchMeRequest);
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'journey/gotJourneys',
            payload: data?.Journeys
          })
        }
      })
    },

    * createWebhookLeadSource({payload}, {call, put, select}) {
      const {response, data} = yield call(createCSVLeadSourceRequest, {
        data: {...payload.allData}
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'fetchMe',
          })
          yield put({
            type: 'fetchLeadSource',
            payload: {id: data?.data?.lead_source?.id}
          })
          try {
            if (payload?.cb) payload?.cb(null, data?.data);
          } catch (error) {
            console.error('Error in callback:', error);
          }
        }
        , * onError(error) {
          message.error(error?.error?.message)

        }
      })
    },
    * updateWebhookLeadSource({payload}, {call, put, select}) {
      const {response, data} = yield call(updateCSVLeadSourceRequest, {
        data: {...payload.allData},
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          try {
            yield put({
              type: 'fetchMe',
            })
            yield put({
              type: 'fetchLeadSource',
              payload: {id: data?.data?.lead_source?.id}
            })
            if (payload?.cb) payload?.cb(null, data?.data);
          } catch (error) {
            console.error('Error in callback:', error);
          }
        }
        , * onError(error) {

          message.error(error?.error?.message)

        }
      })


    },
    * createCSVLeadSource({payload}, {call, put, select}) {
      const {response, data} = yield call(createCSVLeadSourceRequest, {
        data: {...payload.allData}
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'fetchMe',
            payload: data?.data
          })
          yield put({
            type: 'leads/createCSVLeads',
            payload: {
              ...payload, sourceId:
              data?.data?.lead_source?.id
            }
          })
        }
        , * onError(error) {
          message.error(error?.error?.message)

        }
      })


    },

    * deleteLeadSource({payload: {id, cb, intl}}, {call, put}) {

      const {response, data} = yield call(deleteLeadSource, {params: {sourceId: id}});
      yield processAPIResponse({response, data}, {
        * onSuccess() {
          yield put({
            type: 'fetchMe',
          })
          intl && message.success(intl.formatMessage({
            id: "pages.leads.removeLeadSourceSuccess",
            defaultMessage: 'Lead Source deleted successfully'
          }))
          cb && cb(data)
        },
        * onError({error}) {
          cb && cb(error)
          message.error(error?.message || intl.formatMessage({
            id: "pages.leads.removeLeadSourceFailed",
            defaultMessage: 'Remove Lead Source failed'
          }))
        },
      })
    },
    * fetchLeadSource({payload: {id}}: { payload: { id?: string } }, {call, put, select}) {
      const {response, data} = yield call(getLeadSource, {params: {sourceId: id}});
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'saveLeadSourceDetail',
            payload: data,
          })
        }
      }, 'data')
    },
    * updateCSVLeadSource({payload}, {call, put, select}) {
      const callback = payload?.cb

      const {response, data} = yield call(updateCSVLeadSourceRequest, {
        data: {...payload.allData},
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {

          yield put({
            type: 'fetchMe',
          })
          yield put({
            type: 'leads/createCSVLeads',
            payload: {
              ...payload, sourceId:
              data?.data?.lead_source?.id
            }
          })
        }
        , * onError({error}) {
          callback && callback(error, false)

          message.error(error?.error?.message)

        }
      })


    },
  },

  reducers: {
    setLeadSources(state, action) {
      const {
        payload: {leadSourceList},
      } = action;

      return {
        ...state,
        leadSourceList
      };
    },

    setManagedLeadSources(state, action) {
      return {
        ...state,
        managedList: action.payload.managedList,
      };
    },

    updateManagedLeadSource(state, action) {
      const {leadSource} = action.payload;
      return {
        ...state,
        managedList: (state.managedList || []).map((item) =>
          item.id === leadSource.id ? {...item, ...leadSource} : item
        ),
      };
    },

    setDefaultManagedLeadSource(state, action) {
      const {id} = action.payload;
      return {
        ...state,
        managedList: (state.managedList || []).map((item) => ({
          ...item,
          is_default: item.id === id,
        })),
      };
    },

    saveLeadFields(state, action) {
      return {
        ...state,
        leadFields: action.payload,
      };
    },

    saveLeadSourceDetail(state, action) {
      return {
        ...state,
        leadSourceDetail: action.payload,
      };
    },
    reset(){
      return initialState
    }
  }
};
